import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  email: "info@centrumforalla.se",
  phone: "0700123456",
  business: "Centrum för alla",
  adress: "Din partner för digitala lösningar i Sverige",
  zip: "Huvudkontor: ",
  city: "Stockholm",
  coords: { lat: 59.3293, lng: 18.0686 },
  weatherData: [],
  searchTerms: [
    "Webbutveckling",
    "SEO-optimering",
    "Digital Marknadsföring",
    "E-handel",
    "Social Media Hantering",
    "Annonsering",
  ],
};

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    setWeatherData: (state, { payload }) => {
      state.weatherData = payload;
    },
  },
});

export const { setWeatherData } = customerSlice.actions;
export const getCustomerData = (state) => state.customer;
export const getCustomerEmail = (state) => state.customer.email;
export const getCustomerPhone = (state) => state.customer.phone;
export default customerSlice.reducer;
